import { AccountInfo , AccountMatrix, AccountRestrictions} from "store/account/account-state";

export const getAccountNoFromAccountInfo = (
  accountInformationId: number,
  accountInfo: AccountInfo[]
) => {
  for (let account of accountInfo) {
    if (accountInformationId === account.id) {
      return account.accountNumber;
    }
  }
  return undefined;
};

export const hasAccountPermission = (clientAttribute: number | null | undefined, accountMatrix: AccountMatrix ) => {
  if(clientAttribute == null) {
    return false;
  }

  return (clientAttribute & accountMatrix) === accountMatrix;
};

export const hasClientAccountPermission = (
  clientAttribute: number | null | undefined,
  clientPermission: string[],
  matrixMap: Record<string, AccountMatrix>
): boolean => {
  return clientPermission.every(clientPermission => hasAccountPermission(clientAttribute, matrixMap[clientPermission])
  );
};

export const getAccountRestrictionWarning = (restrictions: AccountRestrictions): string=> {
  if(restrictions.isInactive) {
    return "common:account_inactive";
  }
  else if (restrictions.achRestricted && restrictions.cardRestricted) {
    return "common:payments_blocked";
  }
  else if(restrictions.achRestricted) {
    return "common:payments_blocked_ach";
  }
  else if(restrictions.cardRestricted) {
    return "common:payments_blocked_card";
  }

  return "";
}
